import { combineReducers } from '@reduxjs/toolkit';
import lunaStreamsReducers from '@vlabs/monokit/entities/sources/luna-streams/store/reducer';

import eventsSlice from '@vlabs/pages/events/events/store';
import latestEventsSlice from '@vlabs/pages/events/latest-events/store';
import handlerSlice from '@vlabs/pages/handlers/store';
import listsSlice from '@vlabs/pages/lists/store';
import accountSlice from '@vlapps/luna/src/features/auth/store';

import appSlice from './appSlice';

export default combineReducers({
  app: appSlice,
  account: accountSlice,
  lists: listsSlice,
  events: eventsSlice,
  latestEvents: latestEventsSlice,
  handlers: handlerSlice,
  ...lunaStreamsReducers,
});
